import { render, staticRenderFns } from "./jiaofeiRecord.vue?vue&type=template&id=32b69f14&scoped=true&"
import script from "./jiaofeiRecord.vue?vue&type=script&lang=js&"
export * from "./jiaofeiRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b69f14",
  null
  
)

export default component.exports